
<style>
    .form-material select, .form-material input, .form-material textarea, languageSelector select {
      width: 100%;
      font-size:14px;
    }

  .form-material select {
    font-size:14px;
    font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  }

  .languageContainer {
    display:block;
    margin-bottom:10px;
  }

  .globalContainer {
    display:block;
    margin-bottom:10px;
  }

</style>

<app-modal-header [headerTitle]="'Edit Bible Book'" (languageSelected)="setSelectedLanguage($event)"></app-modal-header>

<div mat-dialog-content>

  <div *ngIf="CurrentLocalizedData() != null" style="border-bottom:1px solid gray">
      {{currentLanguage.Name}}
  </div>

  <div *ngIf="CurrentLocalizedData() != null" class="languageContainer">

      <div class="form-group row">
          <div class="col-6">
              <div class="form-material">
                  <input matInput Xplaceholder="Name" [(ngModel)]="CurrentLocalizedData().Name">
                  <label for="">Name</label>
              </div>
          </div>

          <div class="col-6">
              <div class="form-material">
                  <input matInput Xplaceholder="Spoken Name" [(ngModel)]="CurrentLocalizedData().Description">
                  <label for="">Spoken Name</label>
              </div>
          </div>
      </div>

      <div class="form-group row">
          <div class="col-6">
              <div class="form-material">
                  <input matInput Xplaceholder="Abbreviated Name" [(ngModel)]="CurrentLocalizedData().AbbreviatedName">
                  <label for="">Abbreviated Name</label>
              </div>
          </div>

          <div class="col-6">
              <div class="form-material">
                  <input matInput Xplaceholder="Alternate Name" [(ngModel)]="CurrentLocalizedData().AlternateName">
                  <label for="">Alternate Name</label>
              </div>
          </div>
      </div>

  </div>

  <div  style="border-bottom:1px solid gray">All Languages</div>
  <div class="globalContainer">


      <div class="form-group row">
          <div class="col-6">
              <div class="form-material">

                  <select Xplaceholder="Language" [ngModel]="item.Section?.Id" (ngModelChange)="changeSection($event)">
                      <option *ngFor="let section of bibleBookSections"  [selected]="section.Id == item.Section?.Id" [ngValue]="section.Id">
                          {{section.Localized[0].Name}}
                      </option>
                    </select>

                  <label for="">Section</label>
              </div>
          </div>

          <div class="col-6">
              <div class="form-material">
                  <input matInput Xplaceholder="Display Order" [(ngModel)]="item.DisplayOrder">
                  <label for="">Display Order</label>
              </div>
          </div>

          <div class="col-6">
              <div class="form-material">
                  <input matInput Xplaceholder="Spoken Name" [(ngModel)]="item.NumberOfChapters">
                  <label for="">Number Of Chapters</label>
              </div>
          </div>
      </div>

      <div class="form-group row">
          <div class="col-12">
              <div class="form-material">
                  <textarea matInput Xplaceholder="Comments" [(ngModel)]="item.Comments"></textarea>
                  <label for="">Comments</label>
              </div>
          </div>

      </div>



  </div>


</div>
<div mat-dialog-actions class="float-right">
  <button mat-button (click)="cancel()" class="btn btn-sm btn-outline-secondary" style="margin-right:10px">Cancel</button>
  <button mat-button (click)="save()"   class="btn btn-sm btn-outline-primary">Save</button>

</div>
